import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import styles from "./BlogPage.module.css";
import logoImage from "../../assets/images/canacon_logo2.png";

const NewsPage = () => {
  const [isVisible, setIsVisible] = useState(false);
  
  useEffect(() => {
    setIsVisible(true);
    
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
  }, []);
  
  const newsArticles = [
    {
      id: 1,
      title: "From Scare Ads to Smart Ads: Using Data the Right Way in 2025",
      excerpt: "Many people first learned how much the web knows about them when a VPN banner appeared this spring. The ad greeted each viewer with oddly precise facts and then warned that only a paid subscription could hide that information.",
      date: "June 23, 2025",
      category: "Digital Marketing",
      image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?q=80&w=1200&auto=format&fit=crop",
      author: {
        name: "Onur Gul",
        avatar: logoImage
      },
      slug: "from-scare-ads-to-smart-ads-using-data-right-way-2025",
      readTime: "6 min read",
      featured: true
    },
    {
      id: 2,
      title: "Beyond the Click: Adapting SEO to AI-Driven Search in 2025",
      excerpt: "The past few months have felt like a plot twist for anyone who watches their analytics first thing in the morning. Google's new AI Overviews began showing full answers at the top of countless queries, cutting the need to click through to a site at all.",
      date: "June 20, 2025",
      category: "Technology",
      image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?q=80&w=1200&auto=format&fit=crop",
      author: {
        name: "Onur Gul",
        avatar: logoImage
      },
      slug: "beyond-click-adapting-seo-ai-driven-search-2025",
      readTime: "5 min read",
      featured: false
    }
  ];

  const featuredArticle = newsArticles.find(article => article.featured);
  const regularArticles = newsArticles.filter(article => !article.featured);

  return (
    <div className={styles.newsPage}>
      {/* News Header */}
      <div className={styles.newsHeader}>
        <div className={styles.container}>
          <div className={styles.headerContent}>
            <div className={styles.newsbranding}>
              <h1 className={`${styles.pageTitle} ${isVisible ? styles.visible : ""}`}>
                Canacon News
              </h1>
              <div className={`${styles.tagline} ${isVisible ? styles.visible : ""}`}>
                Technology • Marketing • Digital Innovation
              </div>
            </div>

          </div>
        </div>
      </div>
      
      {/* Featured Article */}
      {featuredArticle && (
        <div className={styles.featuredSection}>
          <div className={styles.container}>
            <div className={`${styles.featuredArticle} ${isVisible ? styles.visible : ""}`}>
              <div className={styles.featuredContent}>
                <div className={styles.featuredMeta}>
                  <span className={styles.category}>{featuredArticle.category}</span>
                  <span className={styles.readTime}>{featuredArticle.readTime}</span>
                </div>
                <Link to={`/news/${featuredArticle.slug}`} className={styles.featuredLink}>
                  <h2 className={styles.featuredTitle}>{featuredArticle.title}</h2>
                </Link>
                <p className={styles.featuredExcerpt}>{featuredArticle.excerpt}</p>
                <div className={styles.articleMeta}>
                  <div className={styles.authorInfo}>
                    <img src={featuredArticle.author.avatar} alt={featuredArticle.author.name} className={styles.authorAvatar} />
                    <div className={styles.authorDetails}>
                      <span className={styles.authorName}>By {featuredArticle.author.name}</span>
                      <span className={styles.publishDate}>{featuredArticle.date}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.featuredImage}>
                <Link to={`/news/${featuredArticle.slug}`}>
                  <img src={featuredArticle.image} alt={featuredArticle.title} />
                </Link>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* More Articles Section */}
      {regularArticles.length > 0 && (
        <div className={styles.articlesSection}>
          <div className={styles.container}>
            <div className={styles.sectionHeader}>
              <h3 className={styles.sectionTitle}>More News</h3>
              <div className={styles.sectionLine}></div>
            </div>
            <div className={`${styles.articlesGrid} ${isVisible ? styles.visible : ""}`}>
              {regularArticles.map((article) => (
                <article key={article.id} className={styles.articleCard}>
                  <Link to={`/news/${article.slug}`} className={styles.articleLink}>
                    <div className={styles.articleImage}>
                      <img src={article.image} alt={article.title} />
                    </div>
                    <div className={styles.articleContent}>
                      <div className={styles.articleMeta}>
                        <span className={styles.category}>{article.category}</span>
                        <span className={styles.publishDate}>{article.date}</span>
                      </div>
                      <h3 className={styles.articleTitle}>{article.title}</h3>
                      <p className={styles.articleExcerpt}>{article.excerpt}</p>
                      <div className={styles.authorInfo}>
                        <span className={styles.authorName}>By {article.author.name}</span>
                        <span className={styles.readTime}>{article.readTime}</span>
                      </div>
                    </div>
                  </Link>
                </article>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Newsletter Signup */}
      <div className={styles.newsletterSection}>
        <div className={styles.container}>
          <div className={`${styles.newsletterContent} ${isVisible ? styles.visible : ""}`}>
            <h3 className={styles.newsletterTitle}>Stay Informed</h3>
            <p className={styles.newsletterDescription}>
              Get the latest insights on technology, marketing, and digital innovation delivered to your inbox.
            </p>
            <div className={styles.newsletterForm}>
              <input 
                type="email" 
                placeholder="Enter your email address" 
                className={styles.emailInput}
              />
              <button className={styles.subscribeButton}>Subscribe</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsPage; 